module.exports = __webpack_public_path__ + "img/slide-3-ua.da8eeabf.png";